module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swiper-fullscreen"
  }, [_c('swiper', {
    ref: "wechatSwiper",
    attrs: {
      "is-pagination": false,
      "height": '100%',
      "loop": false,
      "autoplay": 5000
    }
  }, [_c('swiper-item', [_c('div', {
    staticClass: "cover-wrapper",
    staticStyle: {
      "height": "100%",
      "background-image": "url('/static/img/wechat-1.png')"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/wechat-1.png"
    }
  })])]), _vm._v(" "), _c('swiper-item', [_c('div', {
    staticClass: "cover-wrapper",
    staticStyle: {
      "height": "100%",
      "background-image": "url('/static/img/wechat-2.png')"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/wechat-2.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "anim-container"
  }, [_c('div', {
    staticClass: "back"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/wechat-anim-bg.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "front"
  }, [_c('div', {
    staticClass: "anim anim-1",
    class: {
      'active': _vm.currentIndex == 0
    }
  }, [_c('div', {
    staticClass: "tips"
  }, [_c('h4', [_vm._v("产品介绍")]), _vm._v(" "), _c('p', [_vm._v("丰富的贷款产品，充分享受随时随地申请的便利")])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/img/wechat-anim-1.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "anim anim-2",
    class: {
      'active': _vm.currentIndex == 1
    }
  }, [_c('div', {
    staticClass: "tips"
  }, [_c('h4', [_vm._v("我的订单")]), _vm._v(" "), _c('p', [_vm._v("实时掌握您的借款动态")])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/img/wechat-anim-2.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "anim anim-3",
    class: {
      'active': _vm.currentIndex == 2
    }
  }, [_c('div', {
    staticClass: "tips"
  }, [_c('h4', [_vm._v("关于我们")]), _vm._v(" "), _c('p', [_vm._v("一对一的专业客服在线帮助")])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/img/wechat-anim-3.png"
    }
  })])])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-97b914ba"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/wechat.vue
// module id = 618
// module chunks = 1